module.exports = __webpack_public_path__ + "media/img/frontend_application/Bannertablet-8a98589f12e1908e519fa18160971cb8.png";